export const PROJECT_GROUP_MEDIAS_COMPONENT_ID = "projectGroupMediasComponentId";
